import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import React from 'react';
import { PreferenceDeleteCheck } from '../../types/Preference';

interface PreferenceDeleteCheckModalProps {
  isOpen: boolean;
  usages: PreferenceDeleteCheck[];
  onClose: () => void;
}

export default function PreferenceDeleteCheckModal({ isOpen, usages, onClose }: PreferenceDeleteCheckModalProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <DialogTitle>Cannot Delete Preference</DialogTitle>
      <DialogContent>
        <Typography>This preference is currently in use. Please un-associate it from the following items before deleting:</Typography>
        <Box mt={2}>
          {usages.map((usage, index) => (
            <Box key={index} mb={1}>
              <Link href={usage.path} target="_blank" rel="noopener">
                {usage.label}
              </Link>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
